module.exports = __webpack_public_path__ + "static/media/xchange.dcdd8f5d.png";